import React from "react";
import { useTranslation } from "react-i18next";
import { UserCircle } from "@phosphor-icons/react";
import ReadMoreHtml from "Components/ReadMoreHtml";

// Matches the site's established gradient card language (Contact page,
// course-detail Instructor box) instead of a flat `bg-grey` panel.
const AboutSection = ({ data }) => {
  const { t } = useTranslation();

  if (!data?.description) return null;

  return (
    <div className="py-8">
      <div className="bg-gradient-to-br from-grey to-grey/50 rounded-2xl shadow-xl border border-gray-800 p-6 sm:p-8">
        <div className="flex items-center gap-2 mb-5">
          <UserCircle size={22} className="text-primary" weight="fill" />
          <h2 className="text-xl sm:text-2xl font-semibold text-white">
            {t("general.about", "About")} {data?.name}
          </h2>
        </div>

        <ReadMoreHtml
          html={data?.description}
          maxChars={280}
          className="text-white/70 leading-relaxed prose prose-invert max-w-none"
        />
      </div>
    </div>
  );
};

export default AboutSection;
